
<template>
    <div id="banner-card-main" class="col-xl-3 col-sm-6">
        <div class="card border shadow-sm">
        <div @click="() => this.$emit('edit', banner)" id="banner-card-body" class="card-body p-3">
            <div class="d-flex mb-2 pb-1 border-bottom">
            <div class="avatar flex-shrink-0 me-2">
                <img
                :src="banner.bannerImageSrc"
                alt=""
                @error="(e) => e.target.src = require('@/assets/images/img-placeholder.png')"
                class="img-thumbnail border border-info img-cover"
                />
            </div>
            <div
                class="flex-grow-1r align-self-center overflow-hidden"
            >
                <h5 class="mb-0 text-truncate">
                <b-link
                    
                    class="text-primary font-size-14 fw-bold"
                >
                    {{banner.bannerName | truncator(20,'...')}}</b-link

                >
                </h5>
                <p class="small">{{banner.destinations.type}} <span class="text-dark">({{banner.destinations.name  | truncator(10,'...')}})</span></p>
            </div>
            </div>

            <div class="d-flex justify-content-between">
            <div class="form-check form-switch">
                <div v-if="banner.bannerActiveNow">
                    <input class="form-check-input" type="checkbox" id="flexSwitchCheckDisabled" checked disabled>
                    <label class="form-check-label" for="flexSwitchCheckDisabled"><span class="text-success">active</span></label>
                </div>
                <div v-else>
                    <input class="form-check-input" type="checkbox" id="flexSwitchCheckDisabled" disabled>
                    <label class="form-check-label" for="flexSwitchCheckDisabled"><span class="text-danger">inactive</span></label>
                </div>
            </div>
            </div>
        </div>
        <!-- end card body -->
        <div class="btn-group btn-icon" role="group">
            <button
            class="btn btn-outline-light"
             @click="() => this.$emit('delete', banner)"
            >
            <i class="text-danger mdi mdi-delete"></i>
            </button>
        </div>
        </div>
        <!-- end card -->
    </div>
    <!-- end col -->
</template>

<script>
export default {
    props: ['banner']
}
</script>
<style scoped>
   
    #banner-card-main:hover {
        -moz-transition: all 0.2s ease-in;
        -o-transition: all 0.2s ease-in;
        -webkit-transition: all 0.2s ease-in;
        transition: all 0.2s ease-in;
        transform: scale(1.05);
        cursor: pointer;
    }

    .img-cover {
        object-fit: cover;
    }
</style>